import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { signIn } from "../lib/auth-client.ts";
import { AuthDivider, GoogleButton } from "../components/GoogleButton.tsx";

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await signIn.email({ email, password });
      if ((res as { error?: { message?: string } })?.error) {
        setError((res as { error?: { message?: string } }).error?.message ?? "Sign in failed.");
        return;
      }
      navigate("/", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign in failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-wrap animate-fade-in">
        <div className="auth-logo">
          <div className="auth-logo-mark">
            <img src="/logo.webp" alt="CurrencyCore" />
          </div>
          <h1>CurrencyCore Admin</h1>
          <p>Restricted to platform administrators</p>
        </div>

        <div className="auth-card">
          {error && <div className="error-banner">{error}</div>}

          <GoogleButton />
          <AuthDivider />

          <form onSubmit={handleSubmit} className="form-stack">
            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="you@currency-core.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                placeholder="••••••••"
              />
            </div>

            <button type="submit" disabled={loading} className="btn btn-primary btn-block">
              {loading ? (
                <>
                  <span className="spinner" />
                  Signing in…
                </>
              ) : (
                "Sign in"
              )}
            </button>
          </form>
        </div>

        <p className="auth-footer">
          Access is granted by the <code>ADMIN_EMAILS</code> allowlist.
        </p>
      </div>
    </div>
  );
}
